import { SeoTrackingEvent } from 'nexchange-service/module/seo'
import { TUserDataMarketing } from 'nexchange-service/module/auth'

class UserCreateEvent implements SeoTrackingEvent {
    eventName = 'user.create'
    userData: TUserDataMarketing | undefined

    constructor(userData: TUserDataMarketing) {
        this.userData = userData
    }
}

export { UserCreateEvent }
